// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"721":"3aa02096b2631840","9761":"298921d18a4c1efc"}[chunkId] + ".css";
};